import { AxiosError } from 'axios'
import { ok, err, Result } from 'neverthrow'
import { ExpertsClient } from './base-clients/experts.client'

type FileUploadApiResponseType = {
    data: {
        [key: string]: {
            download_url: string
            upload_url: string
            expiry: string
        }
    }
}

export const getSignedURLSByPathAPI = async (
    path: string
): Promise<Result<FileUploadApiResponseType, AxiosError>> => {
    try {
        const resp = await ExpertsClient.post(`v1/internal-view/get-signed-urls`, {
            paths: [path],
        })
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}
